export function path(to: string, obj: object) {
  return to.split('.').reduce((previous, current) => previous && previous[current], obj);
}
